export const GET_USER = 'user/GET_USER'
export const REGISTER = 'user/REGISTER'
export const CREATE_BANNERS = 'user/CREATE_BANNERS'
export const FETCH_AVAILABLE_EVENTS = 'user/FETCH_AVAILABLE_EVENTS'
export const ADD_NEW_AVAILABILITIES = 'user/ADD_NEW_AVAILABILITIES'
export const TOGGLE_NEW_CREATED_EVENT = 'user/TOGGLE_NEW_CREATED_EVENT'
export const ACTIVATE = 'user/ACTIVATE'
export const UPDATE_ABOUT = 'user/UPDATE_ABOUT'
export const UPDATE_REGISTRATION_ABOUT = 'user/UPDATE_REGISTRATION_ABOUT'
export const UPDATE_NAME_PICTURE = 'user/UPDATE_NAME_PICTURE'
export const SET_SELECTED_CATEGORIES = 'user/SET_SELECTED_CATEGORIES'
export const SET_ACTIVE_CATEGORY = 'user/SET_ACTIVE_CATEGORY'
export const LAST_PASSED_CATEGORY = 'user/LAST_PASSED_CATEGORY'
export const SET_ACTIVE_CATEGORY_INDEX = 'user/SET_ACTIVE_CATEGORY_INDEX'
export const SET_STEP = 'user/SET_STEP'
export const SET_SWITCH_STEP = 'user/SET_SWITCH_STEP'
export const CREATE_STUDENT_GOAL = 'user/CREATE_STUDENT_GOAL'
export const GET_RANDOM_TEST = 'user/GET_RANDOM_TEST'
export const CANCEL_TEST = 'user/CANCEL_TEST'
export const SUBMIT_TEST = 'user/SUBMIT_TEST'
export const SET_CREATE_BANNER_STEP = 'user/SET_CREATE_BANNER_STEP'
export const GET_BANNERS = 'user/GET_BANNERS'
export const GET_BANNER = 'user/GET_BANNER'
export const GET_CLASS_BANNER_CATEGORIES = 'user/GET_CLASS_BANNER_CATEGORIES'
export const GET_TUTOR_TEST_RECORDS = 'user/GET_TUTOR_TEST_RECORDS'
export const GET_TEST_CATEGORIES = 'user/GET_TEST_CATEGORIES'
export const SWITCH_ROLE = 'user/SWITCH_ROLE'
export const ROLE_SWITCHED = 'user/ROLE_SWITCHED'
export const USER_SIGN_IN = 'user/SIGN_IN'
export const GET_PAYMENT_OPTIONS = 'user/GET_PAYMENT_OPTIONS'
export const DELETE_CLASS_BANNER = 'user/DELETE_CLASS_BANNER'
export const EDIT_CLASS_BANNER = 'user/UPDATE_CLASS_BANNER'
export const RESET_BANNER = 'user/RESET_BANNER'
export const GET_MAIN_CATEGORIES = 'user/GET_MAIN_CATEGORIES'
export const ACTIVATE_TWO_FACTOR_AUTH = 'user/ACTIVATE_TWO_FACTOR_AUTH'
export const DEACTIVATE_TWO_FACTOR_AUTH = 'user/DEACTIVATE_TWO_FACTOR_AUTH'
export const VERIFY_TWO_FACTOR_AUTH = 'user/VERIFY_TWO_FACTOR_AUTH'
export const CHANGE_PASSWORD = 'user/CHANGE_PASSWORD'
export const SEND_RESET_PASSWORD_EMAIL = 'user/SEND_RESET_PASSWORD_EMAIL'
export const GET_STUDENT_GOAL = 'user/GET_STUDENT_GOAL'
export const EDIT_STUDENT_GOAL = 'user/EDIT_STUDENT_GOAL'
export const RESET_PASSWORD = 'user/RESET_PASSWORD'
export const DELETE_ACCOUNT = 'user/DELETE_ACCOUNT'
export const GET_LOGIN_HISTORY = 'user/GET_LOGIN_HISTORY'
export const GET_LINKED_DEVICES = 'user/GET_LINKED_DEVICES'
export const LOGOUT_FROM_ALL_DEVICES = 'user/LOGOUT_FROM_ALL_DEVICES'
export const LOGOUT = 'user/LOGOUT'
export const RESET_SIGN_IN_ERROR = 'user/RESET_SIGN_IN_ERROR'
export const UPDATE_CURRENT_REGISTRATION_STEP = 'user/UPDATE_CURRENT_REGISTRATION_STEP'
export const SEND_CONFIRMATION = 'user/SEND_CONFIRMATION_EMAIL'
export const INITIATE_TEST = 'user/INITIATE_TEST'
export const GET_VERIFY = 'user/GET_KYC_VERIFICATION'
export const GET_VERIFYSTATUS = 'user/GET_KYC_VERIFICATION_STATUS'
export const CLEAR_INSTRUCTION_ERROR = 'test/CLEAR_INSTRUCTION_ERROR'
export const TOGGLE_FULLSCREEN = 'app/TOGGLE_FULLSCREEN'
export const GET_TUTORS = 'user/GET_TUTOR_LIST'
export const GET_TUTOR_WITH_FILTERS = 'user/GET_TUTOR_WITH_FILTERS'
